<template>
	<div>
		<h1 class="view-title" data-v-step-customer="1">
			CLIENTES <span v-popover:tooltip.right="'Seção de gerenciamento dos Clientes'"><i class="fas fa-question-circle"></i></span>
		</h1>
		<div class="inner-content shadowed">
			<div class="inner-content-title">
				Lista <span v-popover:tooltip.right="'Lista dos clientes cadastrados'"><i class="fas fa-question-circle"></i></span>
				<button v-if="client_atak" class="btn-customer" @click="show_modal_synchronization_atak = true" data-v-step-customer="4">
					<i class="fa fa-sync"></i> SINCRONIZAR
				</button>
				<button class="btn-customer" @click="newCustomer" data-v-step-customer="3" :disabled="!$permission.hasAreaEditPermission('Customer')">
					<i class="fa fa-plus"></i> ADICIONAR
				</button>
				<button class="btn btn-link btn-right" @click="$refs.tour.editTour()" style="margin-top: 10px; margin-left: 15px;" data-v-step-customer="2">
                    <i class="fas fa-question-circle"></i> TOUR
                </button>
			</div>
			<div class="row">
				<div class="col-xs-12 col-lg-12">
					<div class="container-filter">
						<div class="row">
							<div class="col-xs-12 col-lg-12 collapse-header" @click="show_filters = !show_filters">
								<div class="container-collapse-header" :data-v-step-customer="client_atak ? '5' : '4'">
									<span><b><i class="fa fa-fw fa-sliders-h"></i> Filtros <span v-popover:tooltip.right="'Campos para filtragem do registro desejado'"><i class="fas fa-question-circle"></i></span></b></span>
									<span class="collapse-header-arrow" v-if="show_filters"><i class="fa fa-chevron-up"></i></span>
									<span class="collapse-header-arrow" v-else><i class="fa fa-chevron-down"></i></span>
								</div>
							</div>
							<div v-if="show_filters" class="col-xs-12 col-lg-12 container-collapse-body">
								<div class="collapse-body">
									<div class="row">
										<div class="col-xs-12 col-lg-2">
											<FormSelect v-model="filters.status" label="Status" :options="options.status" :multiple="false" :required="false" :showAllOptions="true" ref="customer_status_filter" tooltip="Selecione o status desejado" />
										</div>
										<div class="col-xs-12 col-lg-2">
											<FormInputMasked v-model="filters.document" label="Documento" type="text" :required="false" :mask="['###.###.###-##', '##.###.###/####-##']" ref="customer_document_filter" tooltip="Informe o CNPJ/CPF desejado" />
										</div>
										<div class="col-xs-12 col-lg-2">
											<FormInput v-model="filters.code" label="Código do cliente" type="text" :required="false" ref="customer_code_filter" tooltip="Informe o Código do cliente desejado" />
										</div>
										<div class="col-xs-12 col-lg-6">
											<FormInput v-model="filters.name" label="Nome" type="text" :required="false" ref="customer_name_filter" tooltip="Informe o Nome desejado" />
										</div>
										<div class="col-xs-12 col-lg-2">
											<FormInputMasked v-model="filters.postal_code" label="CEP" type="text" :required="false" mask="#####-###" ref="address_postal_code_filter" tooltip="Informe o CEP desejado" />
										</div>
										<div class="col-xs-12 col-lg-3">
											<FormInput v-model="filters.street" label="Logradouro" type="text" :required="false" ref="address_street_filter" tooltip="Informe o logradouro desejado" />
										</div>
										<div class="col-xs-12 col-lg-3">
											<FormInput v-model="filters.neighborhood" label="Bairro" type="text" :required="false" ref="address_neighborhood_filter" tooltip="Informe o bairro desejado" />
										</div>
										<div class="col-xs-12 col-lg-4">
											<FormSelectCourses v-model="filters.city" label="Cidade" :options="options.city" :multiple="true" :required="false" :loading="loading" ref="address_city_filter" tooltip="Informe a cidade desejada" />
										</div>
										<div class="col-xs-12 col-lg-2">
											<FormSelectCourses v-model="filters.uf" label="UF" :options="options.uf" :multiple="true" :required="false" ref="address_uf_filter" tooltip="Selecione a UF desejada" />
										</div>
										<div class="col-xs-12 col-lg-1">
											<FormSelect v-model="per_page" label="Exibir" :options="options.per_page" :showAllOptions="true" ref="per_page_filter" tooltip="Selecione a quantidade a ser exibida" />
										</div>
									</div>
									<div class="row">
										<div class="col-xs-12 col-lg-2">
											<button class="add_new_filters" @click="filter_deliveries()">
												<i class="fas fa-filter"></i> Filtrar
											</button>
										</div>
										<div class="col-xs-12 col-lg-2">
											<button class="add_new_filters" @click="clean_filters()">
												<i class="fas fa-eraser"></i> Limpar
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 col-lg-12">
					<Table 
						:loading="loading"
						:headers="headers" 
						:ordering="ordering" 
						:order="order"
						@reorder="(o) => { order = o; load(); }"
						:list="list" 
						:page="page"
						:per_page="per_page" 
						:total="total" 
						:modifiers="modifiers" 
						@next="() => { page++; load(); }" 
						@prev="() => { page--; load(); }"
						v-slot="{item}"
						:data-v-step-customer="client_atak ? '6' : '5'"
					>
						<button class="button-edit" @click="editCustomer(item)" title="Editar cliente" :disabled="!$permission.hasAreaEditPermission('Customer')">
							<i class="fa fa-fw fa-edit"></i>
						</button>
						<button class="button-edit" @click="setStatus(item.id, item.status)" :title="item.status ? 'Inativar cliente' : 'Ativar  cliente'" :disabled="!$permission.hasAreaEditPermission('Customer')">
							<i class="fa fa-fw" :class="item.status ? 'fa-check-square' : 'fa-square'"></i>
						</button>
						<button v-if="false" class="button-edit" @click="open(item)" title="Detalhes">
							<i class="fa fa-fw fa-file-alt"></i> Detalhes
						</button>

						<button v-if="false" class="button-edit" @click="open_contact(item)" title="Contato">
							<i class="fa fa-fw fa-phone-square-alt"></i> Contato
						</button>
					</Table>
				</div>
			</div>
		</div>

		<customer-form
			v-if="show_modal_form"
			:current="current_form"
		></customer-form>

		<Modal 
		v-if="show_modal_data"
		:title="'DETALHES'"
		@close="current = false">
			<div class="row">
				<div class="col-xs">
					<div class="details-label">CPF/CNPJ</div>
					<div class="details-value">{{ current.document }}</div>
				</div>
				<div class="col-xs">
					<div class="details-label">Razão social</div>
					<div class="details-value">{{ current.name }}</div>
				</div>				
			</div>			

			<hr />

			<div class="row">
				<div class="col-xs">
					<div class="details-label">Endereço</div>
					<div class="details-value">
						CEP {{ current.postal_code }}<br/>
						{{ current.street }}, {{ current.number }} {{ current.complement }} <br/>
						{{ current.neighborhood }}<br/> 
						{{ current.city }}, {{ current.uf }}, {{ current.country }}<br/><br/>
						<i class="fa fa-phone-square-alt"></i> {{ current.phone }}
					</div>
				</div>
				<div class="col-xs">
					<div class="details-label">Contato</div>
					<div class="details-value"><i class="fa fa-fw fa-mobile-alt"></i> {{ current.contact_mobile }}</div>
					<div class="details-value"><i class="fa fa-fw fa-envelope"></i> {{ current.contact_email }}</div>
					<div class="details-value">
						<button class="button-edit" @click="() => { open_contact(current); current = false; }">
							<i class="fa fa-edit"></i> ALTERAR
						</button>
					</div>
				</div>
			</div>

			<hr />
			
			<div class="row">
				<div class="col-xs">
					<div class="details-label">Parâmetros da roterização</div>
					<div class="details-value"><i class="fa fa-fw fa-people-carry"></i> {{ current.average_discharge_time }}</div>					
					<div class="details-value">
						<button class="button-edit" @click="() => { open_parameters(current); current = false; }">
							<i class="fa fa-edit"></i> ALTERAR
						</button>
					</div>
				</div>						
			</div>

			<hr />

			<div class="row">
				<div class="col-xs">
					<div class="details-label">Data criação</div>
					<div class="details-value">{{ (new Date(current.created_at)).toLocaleString() }}</div>
				</div>
				<div class="col-xs">
					<div class="details-label">Última alteração</div>
					<div class="details-value">{{ (new Date(current.updated_at)).toLocaleString() }}</div>
				</div>
			</div>
		</Modal>

		<Modal 
		v-if="contact_info.id !== false"
		:title="'INFORMAÇÕES DE CONTATO'"
		@close="contact_info.id = false"
		@save="save_contact">

			<h4>{{ contact_info.name }} - {{ contact_info.document }}</h4>
			<div class="row">
				<div class="col-xs">
					<FormInput type="email" label="E-mail" icon="fa-envelope" v-model="contact_info.email" />
				</div>
				<div class="col-xs">
					<FormInputMasked type="text" label="Telefone celular" icon="fa-mobile-alt" v-model="contact_info.mobile" mask="+## ## #####-####" />
				</div>
			</div>
		</Modal>

		<Modal 
		v-if="paramets_info.id !== false"
		:title="'PARÂMETROS DA ROTERIZAÇÃO'"
		@close="paramets_info.id = false"
		@save="save_parameters">
			<div class="row">
				<div class="col-xs">
					<FormInputMasked type="tel" label="Tempo médio de descarregamento" icon="fa fa-fw fa-people-carry" v-model="paramets_info.average_discharge_time" :mask="['# min','## min','### min','#### min','##### min']" ref="average_discharge_time" />
				</div>
			</div>
		</Modal>

		<CustomerSynchronizationAtak v-if="show_modal_synchronization_atak"
			:integration="settings.integration"
			:url_api_atak="settings.url_api_atak"
			:default_customer_sync_name="settings.default_customer_sync_name"
		/>

		<Tour
            tour="Customer"
            :steps="tour_steps"
            :callbackOnFinish="true"
			ref="tour"
        />
	</div>
</template>

<script>
import Api from "@/lib/Api";

import Table from "@/components/Table";
import Modal from "@/components/Modal";
import FormInput from "@/components/FormInput";
import FormInputMasked from "@/components/FormInputMasked";
import FormSelect from "@/components/FormSelect";
import FormSelectCourses from "@/components/FormSelectCourses";
import CustomerForm from './Customer/CustomerForm.vue';
import CustomerSynchronizationAtak from './Customer/CustomerSynchronizationAtak.vue';
import Tour from '@/components/Tour';

export default {
	name: "Customer",

	components: {
		Table,
		Modal,
		FormInput,
		FormInputMasked,
		FormSelect,
		FormSelectCourses,
		CustomerForm,
		CustomerSynchronizationAtak,
		Tour,
	},

	data: function() {
		let steps = [
			{
				target: '[data-v-step-customer="0"]',
				header: {
					title: '<code>SEÇÃO CLIENTES</code>',
				},
				content: '<code>Clique no menu <b>CLIENTES</b> para ir a seção de listagem e gerenciamento dos clientes</code>',
				params: {
					placement: 'right',
					highlight: false,
				}
			},
			{
				target: '[data-v-step-customer="1"]',
				header: {
					title: '<code>SEÇÃO ATUAL</code>',
				},
				content: '<code>Identifique pelo título a seção que está atualmente</code>',
				params: {
					placement: 'bottom',
					highlight: true,
				}
			},
			{
				target: '[data-v-step-customer="2"]',
				header: {
					title: '<code>TOUR</code>',
				},
				content: '<code>Em caso de dúvida clique no botão <b>TOUR</b> para gerenciar a exibição do tour nessa seção, e assim ter um auxílio referente aos elementos da página</code>',
				params: {
					placement: 'left',
					highlight: true,
				}
			},
			{
				target: '[data-v-step-customer="3"]',
				header: {
					title: '<code>ADICIONAR CLIENTE</code>',
				},
				content: '<code>Clique no botão <b>ADICIONAR</b> para abrir o formulário de cadastro manual de um novo cliente</code>',
				params: {
					placement: 'left',
					highlight: true,
				}
			},
		];

		if (this.$api.user.company_client_atak) {
			steps = steps.concat([
                {
                    target: '[data-v-step-customer="4"]',
                    header: {
                        title: '<code>SINCRONIZAR CLIENTE</code>',
                    },
                    content: '<code>Clique no botão <b>SINCRONIZAR</b> para abrir o modal de sincronização de cliente com o sistema integrado</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-customer="5"]',
                    header: {
                        title: '<code>FILTRAGEM</code>',
                    },
                    content: '<code>Campo de filtragem da lista</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-customer="6"]',
                    header: {
                        title: '<code>REGISTROS</code>',
                    },
                    content: '<code>Lista dos registros cadastrados</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
            ]);
		} else {
			steps = steps.concat([
                {
                    target: '[data-v-step-customer="4"]',
                    header: {
                        title: '<code>FILTRAGEM</code>',
                    },
                    content: '<code>Campo de filtragem da lista</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-customer="5"]',
                    header: {
                        title: '<code>REGISTROS</code>',
                    },
                    content: '<code>Lista dos registros cadastrados</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
            ]);
		}

		return {
			search: "",
			
			filters: {
                status: 1,
				document: "",
				code: "",
				name: "",
                postal_code: "",
                street: "",
                neighborhood: "",
                city: [],
                uf: [],
            },
			options: {
				status: {
					0: "INATIVO",
					1: "ATIVO",
				},
				city: {},
                uf: {
					'AC': 'AC',
					'AL': 'AL',
					'AP': 'AP',
					'AM': 'AM',
					'BA': 'BA',
					'CE': 'CE',
					'DF': 'DF',
					'ES': 'ES',
					'GO': 'GO',
					'MA': 'MA',
					'MT': 'MT',
					'MS': 'MS',
					'MG': 'MG',
					'PA': 'PA',
					'PB': 'PB',
					'PR': 'PR',
					'PE': 'PE',
					'PI': 'PI',
					'RJ': 'RJ',
					'RN': 'RN',
					'RS': 'RS',
					'RO': 'RO',
					'RR': 'RR',
					'SC': 'SC',
					'SP': 'SP',
					'SE': 'SE',
					'TO': 'TO'
				},
				per_page: {
					25: "25",
					50: "50",
					75: "75",
					100: "100",
				}
            },
			show_filters: false,
			cities_list: [],

			loading: true,
			headers: {
				name: "Nome",
				document: "CPF/CNPJ",
				postal_code: "CEP",
                street: "Endereço",
                number: "Número",
                complement: "Complemento",
                neighborhood: "Bairro",
                city: "Cidade",
                uf: "UF",
			},
			ordering: ["name", "city", "uf"],
            order: 'name-ASC',
			list: [],
			page: 0,
			per_page: 25,
			total: 0,
			modifiers: {
				name: function(d) {
					return `<span class="capitalized" title="${d}">${d.toLowerCase()}</span>`;
				},
				document: function(d) {
					if (d.length > 11) {
						return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
					} else {
						return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
					}
				},
				postal_code: function(d) {
                    return d.replace(/^(\d{5})(\d{3})/, "$1-$2");
				},
				street: function(d) {
					return `<span class="capitalized" title="${d}">${d.toLowerCase()}</span>`;
				},
				number: function(d) {
					return `<span class="capitalized" title="${d}">${d.toLowerCase()}</span>`;
				},
				complement: function(d) {
					return `<span class="capitalized" title="${d}">${d ? d.toLowerCase() : '-'}</span>`;
				},
				neighborhood: function(d) {
					return `<span class="capitalized" title="${d}">${d.toLowerCase()}</span>`;
				},
				city: function(d) {
					return `<span class="capitalized" title="${d}">${d.toLowerCase()}</span>`;
				},
			},

			current: false,
			current_form: false,
			show_modal_form: false,
			show_modal_data: false,
			show_modal_synchronization_atak: false,
			settings: null,

			contact_info: {
				id: false,
				name: '',
				document: '',
				email: '',
				mobile: ''
			},

			paramets_info: {
				id: false,
				average_discharge_time: ''
			},
			
			// Opção atak
			client_atak: this.$api.user.company_client_atak,

            tour_steps: steps,
		};
	},

	beforeCreate: function() {
		if (!this.$permission.hasAreaPermission("Customer")) {
            this.$router.push({ name: 'Home' });
        }
	},

	mounted: async function() {
		this.$refs.tour.setTour();
		if (this.client_atak) {
			await this.loadSettings();
		}
		this.loadCity();
		this.load();
	},

	methods: {
		// Obtém as configurações padrão
        loadSettings: async function() {
            let result = null;
            try {
                result = await Api.post("config/list-my-settings");
            } catch(ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter todas as informações de configuração.");
                return;
            }

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.settings = Object.assign({}, result.data);
					return;
				}
            } else {
				this.$notification.error("Não foi possível obter todas as informações de configuração.");
                return;
			}
        },

		// Carrega a lista de cidades
        loadCity: async function() {
			let result = null;
			try {
				result = await Api.post("delivery/list-my-cities");
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter todas as informações de cidades.");
				return;
			}
			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.options.city = this.optionsCity(result.data);
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter todas as informações de cidades.");
				return;
			}
		},

		load: async function() {
			let form = {};

			form.filters = this.filters;
			if (this.filters.city.length > 0) {
                let cities_array = [];
                this.filters.city.forEach(city => {
                    cities_array = cities_array.concat(this.cities_list[city]);
                });
                form.filters.city = cities_array;
            }
            form.order = this.order;
            form.page = this.page;
            form.per_page = this.per_page;

			let result = null;
			this.list = [];
			this.total = 0;

			this.loading = true;
			try {
				result = await Api.post("customer/list", form);
			} catch (ex) {
				console.log(ex);
				this.loading = false;
				this.$notification.error("Não foi possível obter a lista de clientes.");
				return;
			}
			this.loading = false;

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.list = result.data;
					this.total = result.total;
					return;
				}
			} else {
				this.$notification.error("Não foi possível obter a lista.");
				return;
			}
		},

		optionsCity: function(cities) {
			let r = {};
			cities.map(c => {
                let city = c.city.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toUpperCase();
                if (typeof r[city] !== "undefined") {
                    let cities_aux = this.cities_list[city];
                    if (!cities_aux.includes(c.city)) this.cities_list[city].push(c.city);
                } else {
                    r[city] = city;
                    this.cities_list[city] = [c.city];
                }
			});
			return r;
		},

		open: function(item) {
			this.current = item;
			this.show_modal_data = true;
		},

		open_contact: function(item) {
			this.contact_info.id = item.id;
			this.contact_info.name = item.name || '';
			this.contact_info.document = item.document || '';
			this.contact_info.email = item.contact_email || '';
			this.contact_info.mobile = item.contact_mobile || '';
		},

		open_parameters: function(item) {
			this.paramets_info.id = item.id;

			if (item.average_discharge_time) {
				this.paramets_info.average_discharge_time = item.average_discharge_time;
			} else {
				this.paramets_info.average_discharge_time = '';
			}
		},

		setStatus: async function(id, status) {
			let confirm = await this.$alert.confirm("Deseja mesmo " + (status ? "INATIVAR" : "ATIVAR") + " este cliente?");
			if (!confirm) return;

			let result = null;
			try {
				result = await Api.post("customer/set-status", { id: id });
			} catch (ex) {
                console.log(ex);
                this.loading = false;
                this.$notification.error("Não foi possível concluir a ação.");
                return;
            }

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.$notification.success("Atualizado com sucesso.");
					this.load();
					return;
				}
			} else {
				this.$notification.error("Não foi possível atualizar o status.");
				return;
			}
		},

		save_contact: async function() {
			let form = {};

			if (!this.contact_info.id) return;

			if (this.contact_info.email) {
				form.contact_email = this.contact_info.email;
			}

			if (this.contact_info.mobile) {
				form.contact_mobile = this.contact_info.mobile;
			}

			if (Object.keys(form).length < 1) return;

			form.id = this.contact_info.id;
			
			let result = null;
			this.loading = true;
			try {
				result = await Api.post("customer/save-contact", form);
			} catch (ex) {
                console.log(ex);
                this.loading = false;
                this.$notification.error("Não foi possível concluir a ação.");
                return;
            }
            this.loading = false;

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.$notification.success("Salvo com sucesso.");
					this.contact_info.id = false;

					this.load();
					return;
				}
			} else {
				this.$notification.error("Não foi possível salvar a informação.");
				return;
			}
		},

		save_parameters: async function() {
			let form = {};

			if (!this.paramets_info.id) return;

			if (this.paramets_info.average_discharge_time) {
				let average_discharge_time = this.paramets_info.average_discharge_time.split(" ");
				if(average_discharge_time.length == 2) {
					if(parseInt(average_discharge_time[0]) <= 0) {
						this.$notification.error("Tempo médio de descarregamento não pode ser igual ou menor que zero.");
						this.$refs.average_discharge_time.error = "Valor inválido";
						return;
					}
				} else {
					this.$notification.error("Tempo médio de descarregamento inválido.");
					this.$refs.average_discharge_time.error = "Valor inválido";
					return;
				}
			}

			form.average_discharge_time = this.paramets_info.average_discharge_time;

			if (Object.keys(form).length < 1) return;

			form.id = this.paramets_info.id;

			let result = null;
			this.loading = true;
			try {
				result = await Api.post("customer/save-parameters", form);
			} catch (ex) {
                console.log(ex);
                this.loading = false;
                this.$notification.error("Não foi possível concluir a ação.");
                return;
            }
            this.loading = false;

			if (result) {
				if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return;
					}
				} else {
					this.$notification.success("Salvo com sucesso.");
					this.paramets_info.id = false;

					this.load();
					return;
				}
			} else {
				this.$notification.error("Não foi possível salvar a informação.");
				return;
			}
		},

		newCustomer: function() {
			this.current_form = "new";
			this.show_modal_form = true;
		},

		editCustomer: function (item) {
			this.current_form = item;
			this.show_modal_form = true;
		},

		filter_deliveries: function() {
			this.page = 0;
            this.load();
        },

		clean_filters: function() {
            this.filters.status = 1;
            this.filters.document = "";
            this.filters.code = "";
            this.filters.name = "";
            this.filters.postal_code = "";
            this.filters.street = "";
            this.filters.neighborhood = "";
            this.filters.city = [];
            this.$refs.address_city_filter.clear_selected();
            this.filters.uf = [];
            this.$refs.address_uf_filter.clear_selected();
        },
	}
}

</script>


<style scoped>
.details-label {
	width: 100%;
	font-weight: bold;
	padding: 10px;
}

.details-value {
	width: 100%;
	padding: 10px;
	font-size: 14px;
	color: #999;
}

hr {
	border: none;
	background: none;
	border-top: 1px solid #ddd;
}

.customer-filter-wrapper {
	position: relative;
	float: right;
	width: 200px;
	height: 30px;
	margin-top: 15px;
	color: #999;
}

.customer-filter-wrapper > i {
	position: absolute;
	top: 7px;
	left: 7px;
}

.customer-filter-input {
	position: absolute;
	width: 100%;
	height: 30px;
	padding-left: 30px;
	border-radius: 4px;
	border: 1px solid #ccc;
}

.btn-customer {
	float: right;
	margin-top: 10px;
	border: none;
	background: #d9d9d9;
	color: #000;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;
	margin-left: 15px;
}

.btn-customer:disabled {
	cursor: not-allowed;
	opacity: .4;
}

.container-heading {
    border: 1px solid #f0f0f0;
    border-top: none;
    background-color: #fff;
}
.container-filter {
    background-color: #f0f0f0;
}

.container-collapse-header {
    cursor: pointer;
	padding: 15px;
}

span.collapse-header-arrow {
    float: right;
}

.collapse-body {
    padding: 15px;
	border-top: 1px solid #ddd;
}

.add_new_filters {
	float: right;
	border: none;
	background: #222;
	color: #fff;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;	
    margin-top: 25px;
    width: 100%;
}


</style>